import { call, put, takeLatest } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import { errorHandler } from '../../core/helpers/errorHelpers'

import * as onlineProfilesView from '../reducks/onlineProfiles'
import * as onlineProfilesApi from '../apiModules/onlineProfiles'

function* fetchOnlineProfilesSaga(action) {
  try {
    const response = yield call(onlineProfilesApi.fetchOnlineProfiles, action.payload.id)
    yield put(onlineProfilesView.fetchOnlineProfilesSuccess(response))
  } catch (error) {}
}

function* updateOnlineProfilesSaga(action) {
  try {
    const response = yield call(onlineProfilesApi.updateOnlineProfiles, action.payload.data, action.payload.id)
    yield put(onlineProfilesView.updateOnlineProfilesSuccess(response))
    yield call(action.meta.resolve)
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(onlineProfilesView.updateOnlineProfilesError(error))
    yield call(action.meta.reject, new SubmissionError({ _error: error }))
  }
}

export default function* watchOnlineProfileSaga() {
  yield takeLatest(onlineProfilesView.FETCH_ONLINE_PROFILES, fetchOnlineProfilesSaga)
  yield takeLatest(onlineProfilesView.UPDATE_ONLINE_PROFILES, updateOnlineProfilesSaga)
}
